// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/Niaa-serum.jpg";
import thumb1 from "../assets/images/All-Products/Niaa.png";
import thumb2 from "../assets/images/New-Products/Niaa-serum.jpg";
import thumb3 from "../assets/images/All-Products/Niaa.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Niaa Serum</h2>
              <p className="sub-heading">With an advantage of BioProMela</p>
              <h5>Product Overview</h5>
              <p>
                Niacinamide Vitamin B3 (Niacin) is very stable, water-soluble vitamin which offers wide range of benefits like:
                <ul>
                  <li>Restores the skin's defenses against moisture loss and dehydration.</li>
                  <li>Visibly evens out skin tone and discolorations caused by sun damage.</li>
                  <li>Helps reduce the appearance of existing discolorations for a more even skin tone.</li>
                  <li>Improves skin elasticity, reduces the appearance of fine lines and wrinkles, and supports the skin's barrier function.</li>
                  <li>Suitable for all skin types — normal, dry, oily, and combination.</li>
                </ul>

              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Niaa Serum?</span>
                </h3>
                <p>
                 	Begin by cleansing your face thoroughly, apply few drops of Niaa serum, followed by moisturiser and sunscreen for better result.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients", "storage", "precautions"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : tab === "storage"
                          ? "STORAGE"
                          : tab === "precautions"
                            ? "PRECAUTIONS"
                            : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>10X more absorption than regular water-based serums.</li>
                    <li>Provides potent skin lightening and skin-soothing action.</li>
                    <li>Protects skin cells from UV-induced sun damage.</li>
                    <li>Minimizes acne by reducing sebum secretion.</li>
                    <li>Helps prevent premature aging by effectively preserving the skin barrier with probiotics.</li>
                  </ul>


                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>STEP 1:</strong> Begin by cleansing your face thoroughly. A clean face aids in better absorption and delivers better results.</li>
                      <li><strong>STEP 2:</strong> Using the dropper, apply 5–6 drops of the serum evenly to your face and neck. Gently dab and spread it evenly.</li>
                      <li><strong>STEP 3:</strong> Follow up with a moisturizer and sunscreen for best results.</li>
                    </ul>


                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>
                        <strong>Niacinamide 10%:</strong> A stable form of vitamin B3 that provides multiple topical benefits. It hydrates the skin, treats hyperpigmentation, improves elasticity, reduces redness, and acts as an antioxidant to fight free radicals.
                      </li>

                      <li>
                        <strong>Hexyl-Resorcinol:</strong> A tyrosinase inhibitor that reduces melanin production and transfer to keratinocytes. Also helps in skin brightening.
                      </li>

                      <li>
                        <strong>Hyaluronic Acid 1%:</strong> Retains water to keep tissues hydrated and lubricated while preventing moisture loss. Helps keep the skin plump and moisturized.
                      </li>

                      <li>
                        <strong>Allantoin:</strong> Derived from the comfrey plant. Provides moisturizing, soothing, anti-irritant, anti-aging, and mild exfoliating benefits.
                      </li>

                      <li>
                        <strong>D-Panthenol:</strong> Also known as pro-vitamin B5. Offers moisturizing, healing, and anti-inflammatory properties.
                      </li>

                      <li>
                        <strong>Zinc PCA:</strong> Helps regulate sebum, reduces acne-related inflammation, and provides antimicrobial and antibacterial benefits. Aids in moisture retention and supports collagen synthesis.
                      </li>

                      <li>
                        <strong>Nonapeptide-1:</strong> A biomimetic peptide composed of nine amino acids. Helps reduce skin discoloration and hyperpigmentation, and provides anti-inflammatory effects by reducing MMPs.
                      </li>
                    </ul>


                  </p>
                </div>
              )}
              {activeTab === "storage" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Store below 30° Celsius.</li>
                      <li>Keep in a dry and dark place.</li>
                      <li>Do not freeze.</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "precautions" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Avoid contact with eyes.</li>
                      <li>Use sun protection.</li>
                      <li>Use as directed by the physician.</li>
                      <li>Perform a patch test to check for skin irritation.</li>
                    </ul>

                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
